import { render, staticRenderFns } from "./environmentalMicrobialLoadTesting.vue?vue&type=template&id=6965ba8d&scoped=true&"
import script from "./environmentalMicrobialLoadTesting.vue?vue&type=script&lang=js&"
export * from "./environmentalMicrobialLoadTesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6965ba8d",
  null
  
)

export default component.exports